import { render } from "./NewAdmin.vue?vue&type=template&id=397f8f53&scoped=true"
import script from "./NewAdmin.vue?vue&type=script&lang=js"
export * from "./NewAdmin.vue?vue&type=script&lang=js"

import "./NewAdmin.vue?vue&type=style&index=0&id=397f8f53&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\projects\\SwitchQ-Websockets\\websockets-manager-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397f8f53"]])

export default __exports__